const DEV_AI_ENDPOINTS = {
  CHATGPT_SEARCH: "UseChatGPT",
  ALL_USERS: "api/Users/GetAllUser",
  ALL_LANGUAGES: "api/Answer/GetLanguage",
  LOGIN: "Auth/Login",
  REGISTER: "Auth/Register",
  POST_QUESTION: "api/Question",
  ALL_QUESTIONS: "api/Question",
  ANSWERS_BY_QUESTION: "api/Answer",
  APPROVE: "api/Answer/Approved",
  POST_ANSWER: "api/Answer",
};

export { DEV_AI_ENDPOINTS };
